import React, { useEffect, useState } from 'react';

type Props = {
  label: string;
  minValue: number;
  maxValue: number;
  minValueLimit?: number;
  maxValueLimit?: number;
  textBoxWidth: string;
  onChange?: (minValue: number, maxValue: number) => void;
};

const CheckMin = (min: number, max: number, minLimit?: number): number => {
  var ret = 0;
  if (max >= min) {
    ret = min;
  } else {
    ret = max;
  }

  if (minLimit != null) {
    if (ret < minLimit) {
      ret = minLimit;
    }
  }
  return ret;
};

const CheckMax = (min: number, max: number, maxLimit?: number): number => {
  var ret = 0;
  if (max >= min) {
    ret = max;
  } else {
    ret = min;
  }
  if (maxLimit != null) {
    if (ret > maxLimit) {
      ret = maxLimit;
    }
  }
  return ret;
};

const RangeInputNumber: React.FC<Props> = (props) => {
  const [fromValue, setFromValue] = React.useState<string>(String(props.minValue));
  const [toValue, setToValue] = React.useState<string>(String(props.maxValue));

  useEffect(() => {
    setFromValue(String(props.minValue));
    setToValue(String(props.maxValue));
  }, [props.minValue, props.maxValue]);

  const onChangefromValue = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFromValue(event.target.value);
  };
  const onChangetoValue = (event: React.ChangeEvent<HTMLInputElement>) => {
    setToValue(event.target.value);
  };

  const handlefromFocusEvent = () => {
    var f = Number(fromValue);
    var t = Number(toValue);
    if (isNaN(f)) {
      setFromValue('0');
    } else {
      f = CheckMin(f, t, props.minValueLimit);
      setFromValue(String(f));
      if (props.onChange) {
        props.onChange(f, t);
      }
    }
  };
  const handletoFocusEvent = () => {
    var f = Number(fromValue);
    var t = Number(toValue);
    console.debug(t);
    if (isNaN(t)) {
      setToValue('0');
    } else {
      t = CheckMax(f, t, props.maxValueLimit);
      setToValue(String(t));
      if (props.onChange) {
        props.onChange(f, t);
      }
    }
  };

  return (
    <table>
      <tbody>
        <tr>
          <td> {props.label}</td>
          <td>
            <input
              type="text"
              style={{ width: props.textBoxWidth, textAlign: 'right' }}
              value={fromValue}
              onChange={onChangefromValue}
              onBlur={handlefromFocusEvent}
              onKeyPress={(e) => {
                if (e.key == 'Enter') {
                  handlefromFocusEvent();
                }
              }}
            />
          </td>
          <td> ~ </td>
          <td>
            <input
              type="text"
              style={{ width: props.textBoxWidth, textAlign: 'right' }}
              value={toValue}
              onChange={onChangetoValue}
              onBlur={handletoFocusEvent}
              onKeyPress={(e) => {
                if (e.key == 'Enter') {
                  handletoFocusEvent();
                }
              }}
            />
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default RangeInputNumber;
